var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStreamlineIconNoteAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M20 100a80 80 0 1 0 160 0 80 80 0 1 0-160 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M52.47 60.054h74.97v70.56H52.47Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M52.47 60.054h74.97v70.56H52.47Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M71.214 67.772a3.308 3.308 0 1 1-6.616 0V51.234a3.308 3.308 0 0 1 6.616 0Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M71.214 67.772a3.308 3.308 0 1 1-6.616 0V51.234a3.308 3.308 0 0 1 6.616 0Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M93.264 67.772a3.308 3.308 0 1 1-6.616 0V51.234a3.308 3.308 0 0 1 6.616 0Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M93.264 67.772a3.308 3.308 0 1 1-6.616 0V51.234a3.308 3.308 0 0 1 6.616 0Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M115.314 67.772a3.308 3.308 0 1 1-6.616 0V51.234a3.308 3.308 0 0 1 6.616 0Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M115.314 67.772a3.308 3.308 0 1 1-6.616 0V51.234a3.308 3.308 0 0 1 6.616 0Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M53.97 148.334a36.382 4.41 0 1 0 72.764 0 36.382 4.41 0 1 0-72.764 0"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M108.264 145.082a4.51 4.51 0 0 1-3.98-6.632l28.566-53.558a4.51 4.51 0 0 1 7.958 0l28.566 53.558a4.508 4.508 0 0 1-3.98 6.632Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M108.264 145.082a4.51 4.51 0 0 1-3.98-6.632l28.566-53.558a4.51 4.51 0 0 1 7.958 0l28.566 53.558a4.508 4.508 0 0 1-3.98 6.632Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#2F4386",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M137.898 123.81a1.102 1.102 0 0 1-2.138 0c-4.314-17-4.134-16.24-4.15-16.412a5.242 5.242 0 1 1 10.438 0c-.016.172.166-.598-4.15 16.412"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M136.828 138.15a4.244 4.244 0 1 1 4.244-4.244 4.25 4.25 0 0 1-4.244 4.244"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F4386",
  d: "M136.828 130.664a3.244 3.244 0 1 1-3.24 3.242 3.246 3.246 0 0 1 3.24-3.242m0-2a5.244 5.244 0 1 0 5.244 5.242 5.24 5.24 0 0 0-5.244-5.242"
})));
export default SvgStreamlineIconNoteAlert;